<script>
  import Booking from "./Booking.svelte";
  import DetailView from "./DetailView.svelte";

  export let item;
  export let anmeldestop = false;
  export let eventlistData = {};
  // export let anmeldestopO2o = false;
</script>

<DetailView {item} headline="Workshop" attachmentInfo="Laden Sie sich den Inhalt des Workshops als PDF herunter:" companyNameBeforePerson>
  <Booking slot="whitebox" {item} {anmeldestop} {eventlistData} on:booking on:showVeranstaltung />
</DetailView>
